import { Box, Tab, Tabs } from "@mui/material"
import { ChangeEvent, useEffect, useState } from "react"
import { OverviewUpdated } from "./OverviewUpdatedUI";
import { JobListTaskRecordCollection } from "../components/JobListTaskRecordCollection";

export const TabbedPage = (props: {
    location_id: number,
    location_name: string,
}) => {
    const {location_id, location_name} = props;
    const [value, setValue] = useState<string>("one")
    const handleChange = (event: React.SyntheticEvent, newValue: string) => setValue(newValue);

    useEffect(()=>{},[value])
    return (
    <>
    <Box sx={{
        background: '#F9F9F9',
        height: "89.7vh",
        width: "99.2vw"
    }}>
        <Tabs
        value={value}
        onChange={handleChange}
        sx = {{
            marginLeft: "64px",
            paddingBottom: "32px",
            "& button" : {
                textTransform: 'none',
                fontSize: "32px"
            },
            "& button.Mui-selected": {
                color: "#000000",
            },
            backgroundColor: "#F9F9F9"
        }}
    >
        <Tab value="one" label="Robot" />
        {location_name === "Pharmacy" ? <Tab value="two" label="Jobs" /> : <></>}
    </Tabs>
    {/* {value === "one" ? <Overview currentLocationID={location_id} currentLocationName={location_name} /> : <div></div>} */}
    {value === "one" ? <OverviewUpdated currentLocationID={location_id} currentLocationName={location_name} /> 
            :  "two" ? <JobListTaskRecordCollection currentLocationID={location_id} currentLocationName={location_name} shouldShowAction={true}/> 
            : <></>}
    </Box>
    </>
    )
}